<template>
  <div id="contenedor-etiquetas-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EtiquetasMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
